import {
	INITIATE,
	ENTITY_CREATED,
	ENTITY_CREATE_FAILED,
	CANCELLED,
	type Action,
} from '../../actions/create/index.tsx';
import type { CreateState } from './types.tsx';

const initialState: CreateState = { isOpen: false };

const create = (state: CreateState = initialState, action: Action): CreateState => {
	switch (action.type) {
		case INITIATE: {
			return { isOpen: true };
		}

		case ENTITY_CREATED:
		case ENTITY_CREATE_FAILED:
		case CANCELLED: {
			return { isOpen: false };
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};

export default create;
